import React, { useEffect } from 'react';
import { registerShortcut } from '../shortcuts';

// Reusable confirmation modal.
// props: open, title, message, detail, confirmLabel, danger, onConfirm, onCancel
export default function ConfirmDialog({ open, title = 'Confirm', message, detail, confirmLabel = 'Confirm', danger = false, onConfirm, onCancel }) {
  useEffect(() => {
    if (!open) return;
    return registerShortcut('escape', onCancel);
  }, [open, onCancel]);

  if (!open) return null;
  return (
    <div onClick={onCancel} style={{ position: 'fixed', inset: 0, background: 'rgba(15,8,18,0.55)', zIndex: 1200,
      display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
      <div onClick={e => e.stopPropagation()} style={{ width: 420, maxWidth: '92%', background: 'var(--bg-card, #fff)',
        borderRadius: 14, boxShadow: '0 16px 48px rgba(0,0,0,0.35)', padding: 20 }}>
        <div style={{ fontSize: 15, fontWeight: 800, marginBottom: 8 }}>{title}</div>
        <div style={{ fontSize: 13, lineHeight: 1.5 }}>{message}</div>
        {detail && <div style={{ fontSize: 12, color: 'var(--text-muted, #888)', marginTop: 6 }}>{detail}</div>}
        <div style={{ display: 'flex', gap: 8, justifyContent: 'flex-end', marginTop: 18 }}>
          <button className="btn btn-secondary btn-sm" onClick={onCancel}>Cancel</button>
          <button className={`btn btn-sm ${danger ? 'btn-danger' : 'btn-primary'}`} onClick={onConfirm}>{confirmLabel}</button>
        </div>
      </div>
    </div>
  );
}
